// extracted by mini-css-extract-plugin
export default {"title":"title--3zZ1L","list":"list--2OWRV","listItemLink":"listItemLink--IH135","listItem":"listItem--2ZXxr","icon":"icon--21pJH"};